function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15 22c-.41 0-.75-.34-.75-.75V2.75c0-.41.34-.75.75-.75s.75.34.75.75v18.5c0 .41-.34.75-.75.75z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M6 20h6V4H6C3.79 4 2 5.79 2 8v8c0 2.21 1.79 4 4 4zm12 0h-3V4h3c2.21 0 4 1.79 4 4v8c0 2.21-1.79 4-4 4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 16.25c-.41 0-.75-.34-.75-.75v-7c0-.41.34-.75.75-.75s.75.34.75.75v7c0 .41-.34.75-.75.75z"
})));